import React from 'react';
// Data
import {
  howToBookAdditionalMeta,
  howToBookStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import HowToBookMainContainer from '../../components/booking/HowToBookMainContainer';
import AltHeader from '../../components/general/AltHeader';
import HeaderBanner from '../../components/general/HeaderBanner';
import FooterComponent from '../../components/footer/FooterComponent';

function HowToBook() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='How to Book'
        desc='Learn how to easily book your appointment with Mistress Maria. Find step-by-step instructions, payment options, availability, and important booking policies.'
        keywords='Mistress Maria, how to book, appointment booking, BDSM sessions, payment methods, availability, booking policies, kink, UK sessions'
        additionalMeta={howToBookAdditionalMeta}
        structuredData={howToBookStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        <div className='grid h-fit'>
          {/* Alt */}
          <AltHeader />

          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='grid pt-12'>
            <HeaderBanner message={'How To Book'} />
          </header>
        </div>

        {/* Main page content */}
        <HowToBookMainContainer />

        {/* Footer */}
        <FooterComponent />
      </div>
    </>
  );
}

export default HowToBook;
